import { useCallback, useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial, FindObject } from "../../Common/Utils/ThreeTools"
import { LinearFilter, MeshPhysicalMaterial } from "three"

export default function PetBowl(props: ProductModelProps) {
    /* Gotta load all the models this way because dynamic paths in URL() aren't picked up by webpack */
    const getUrl = useCallback(() => {
        return {
            'small': new URL('@resources/3d-models/glb/pet-bowl-small.glb', import.meta.url),
            'large': new URL('@resources/3d-models/glb/pet-bowl-large.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])

    const model = useGLB(getUrl() || new URL(''))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)
    const option_finish = props.options.get('finish') ?? 'matte'

    // Rotate to align front
    model.scene.rotation.y = Math.PI;

    useEffect(() => {
        if(!elements) return

        let mat = FindMaterial('design', elements) as MeshPhysicalMaterial
        if (!mat) return

        if(option_finish === 'glossy') {
            mat.ior = 2.3;
            mat.specularIntensity = 0.6;
            mat.roughness = 0.3;
            mat.metalness = 0;
        } else {
            mat.ior = 1.4;
            mat.specularIntensity = 0.4;
            mat.roughness = 0.6;
            mat.metalness = 0.1;
        }
    }, [option_finish])

    // Apply lab texture
    useEffect(() => {
        if (!elements) return

        // Disable mipmaps to avoid texture seams
        productTexture.minFilter = LinearFilter

        // Hide Stretcher
        let obj = FindObject("stretcher", elements)
        if (!obj) return
        obj.visible = false
      
        let mat = FindMaterial('design', elements)
        if (!mat) return

        mat.map = productTexture
        mat.map.flipY = false
        mat.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}
